import { render, staticRenderFns } from "./PoliticasDePrivacidade.vue?vue&type=template&id=03672660&scoped=true"
var script = {}
import style0 from "./PoliticasDePrivacidade.vue?vue&type=style&index=0&id=03672660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03672660",
  null
  
)

export default component.exports